
import { Component, Mixins, Prop } from 'vue-property-decorator'
import ButtonReactivate from '~/components/common/buttons/ButtonReactivate.vue'
import Icon from '~/components/common/icon/Icon.vue'
import ApplyReactivate from '~/components/common/maintenance/ApplyReactivate.vue'
import DashboardNewsTickerFeature from '~/components/features/DashboardNewsTicker'
import WinnersBtnFeature from '~/components/features/WinnersBtn'
import GamePoints from '~/components/gamification/GamePoints.vue'
import { NEWS_TICKER_TOGGLED } from '~/plugins/mixpanel/events'
import { NEWS_TICKER_VISIBLE } from '~/plugins/mixpanel/props'
import { isReferralProgramVisible } from '~/lib/utils/referralProgram'

@Component({
  components: {
    GamePoints,
    ButtonReactivate,
    ApplyReactivate,
    Icon
  }
})
export default class UserDropDown extends Mixins(WinnersBtnFeature, DashboardNewsTickerFeature) {
  @Prop({ type: String, default: '' }) packageName!: string
  @Prop({ type: String, default: '' }) packageType!: string
  @Prop({ type: String, default: '' }) date!: string
  @Prop({ type: Boolean, default: false }) isGame!: string
  @Prop({ type: Number, default: 0 }) totalUserPoints!: string

  get newsTickerDismissed() {
    return this.$accessor.ui.newsTickerDismissed
  }

  set newsTickerDismissed(data) {
    this.$accessor.ui.setState({ stateName: 'newsTickerDismissed', data })
  }

  get isPro() {
    return !!this.$auth.user.membership && !this.$auth.user.membership?.freemium && !this.$auth.user.membership?.freeTrial
  }

  get referralProgramVisible() {
    return isReferralProgramVisible(this.$auth.user, this.$featureFlags)
  }

  trackNewsTickerToggle(value: boolean) {
    this.$mixpanel.track(NEWS_TICKER_TOGGLED, {
      [NEWS_TICKER_VISIBLE]: value
    })
  }

  handleNewsTickerToggleButton() {
    const visibility = !this.newsTickerDismissed
    this.newsTickerDismissed = visibility
    this.trackNewsTickerToggle(visibility)
  }
}
